/**
 * deviceDetection.js
 * 모바일 디바이스 감지 유틸리티
 * 
 * 여러 방법을 조합하여 모바일 디바이스를 정확하게 감지합니다:
 * 1. User Agent 기반 감지
 * 2. 화면 너비 기반 감지 (768px 이하)
 * 3. 터치 이벤트 지원 여부 확인
 */

/**
 * 모바일 디바이스인지 감지
 * @returns {boolean} 모바일 디바이스 여부
 */
export const detectMobileDevice = () => {
  if (typeof window === 'undefined') return false;
  
  // User Agent 기반 모바일 디바이스 감지
  const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  
  // 화면 너비 기반 감지 (768px 이하를 모바일로 간주)
  const isSmallScreen = window.innerWidth <= 768;
  
  // 터치 이벤트 지원 여부 확인 (추가 감지 방법)
  const hasTouchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  // 모바일 디바이스이거나 작은 화면이거나 (터치 지원 + 작은 화면)인 경우 모바일로 간주
  return isMobileDevice || isSmallScreen || (hasTouchSupport && isSmallScreen);
};

/**
 * 경로를 모바일 경로로 변환
 * @param {string} path - 변환할 경로
 * @returns {string} 모바일 경로
 */
export const convertToMobilePath = (path) => {
  return path
    .replace(/^\/p\//, '/m/')
    .replace(/^\/p\/dashboard$/, '/m/dashboard')
    .replace(/^\/p\/job-time-input$/, '/m/log')
    .replace(/^\/p\/todo-list$/, '/m/todo')
    .replace(/^\/dashboard$/, '/m/dashboard')
    .replace(/^\/job-time-input$/, '/m/log')
    .replace(/^\/todo-list$/, '/m/todo');
};

/**
 * 경로를 PC 경로로 변환
 * @param {string} path - 변환할 경로
 * @returns {string} PC 경로
 */
export const convertToPcPath = (path) => {
  return path
    .replace(/^\/m\//, '/p/')
    .replace(/^\/m\/dashboard$/, '/p/dashboard')
    .replace(/^\/m\/log$/, '/p/job-time-input')
    .replace(/^\/m\/todo$/, '/p/todo-list');
};

